import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { TipoSegmento } from "../model/tipo-segmento.model";

@Injectable({
    providedIn: 'root'
})
export class TipoSegmentoService {

    private baseUrl = `${environment.apiUrl}/tiposegmento`;

    constructor(
        private http: HttpClient,
        private errorHandler: ApiErrorHandlerService
    ) { }

    findAll(): Observable<TipoSegmento[]> {
        const url = `${this.baseUrl}/listar`;
        return this.http.get<TipoSegmento[]>(url)
            .pipe(catchError(this.errorHandler.handle()));
    }

    buscarTipoSegmento(id: number): Observable<TipoSegmento> {
        const url = `${this.baseUrl}/${id}`;
        return this.http.get<TipoSegmento>(url).pipe(catchError(this.errorHandler.handle()));
    }

    create(tipoSegmento: TipoSegmento): Observable<TipoSegmento> {
        const url = `${this.baseUrl}/create`;
        return this.http.post<TipoSegmento>(url, tipoSegmento).pipe(catchError(this.errorHandler.handle()));
    }

    update(idTipoSegmento: number, tipoSegmento: TipoSegmento): Observable<TipoSegmento> {
        return this.http.put<TipoSegmento>(`${this.baseUrl}/${idTipoSegmento}`, tipoSegmento).pipe(catchError(this.errorHandler.handle()));
    }

    deleteTipoSegmento(idTipoSegmento: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${idTipoSegmento}`).pipe(catchError(this.errorHandler.handle()));
    }
}
